import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
// Components
import { HeaderMainDiv, HeaderDiv, Title } from "./styles";

const ActivitiesHeader = forwardRef(({ title = "activities", showDetailsText = false }, ref) => {
  const [t] = useTranslation("global");

  return (
    <HeaderMainDiv ref={ref}>
      <HeaderDiv>
        <Title width={"330px"} align="left">
          {t(title).toUpperCase()}
        </Title>
        <Title width={"120px"} align="center">
          {t("trainedActivities").toUpperCase()}
        </Title>
        <Title width={"162px"} padding="0 27px" align="center">
          {t("averageTime").toUpperCase()}
        </Title>
        <Title width={"162px"} padding="0 27px" align="center">
          {t("AccumulatedTime").toUpperCase()}
        </Title>
        {showDetailsText && (
          <Title width={"86px"} align="right">
            {t("details").toUpperCase()}
          </Title>
        )}
      </HeaderDiv>
    </HeaderMainDiv>
  );
});

export default ActivitiesHeader;
